import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { IProgramType } from 'legacy/lut/features/partner360/configuration'

export const getAvailableProgramTypes = (programTypes: IProgramType[]) => {
  return programTypes.filter((type) => type.programType !== ProgramTypes.Summary)
}
